import React from 'react'

const SignUpInfoBox = () => {
    return (
        <div className="w-full bg-black70 border-l-4 border-yellow py-3 px-4 rounded-r-xl text-black30 text-sm">
            <p className="mb-2 leading-relaxed">
                <span className="font-semibold text-white">LiftOne Now</span>{' '}
                makes it easy to manage your fleet and daily interactions, such
                as placing repair requests, viewing service history, and
                approving service estimates—all in one place. Submit your
                information below to begin using{' '}
                <span className="font-semibold text-white">LiftOne Now</span>.
            </p>
            <p className="mb-2 text-white text-sm font-semibold">
                Are you looking for something else?
            </p>
            <div className="flex flex-col gap-1">
                <p>
                    For{' '}
                    <span className="font-semibold text-white">
                        Credit Applications
                    </span>
                    , please visit{' '}
                    <a
                        href="https://credit.weisigergroup.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-yellow underline hover:opacity-80 transition-opacity"
                    >
                        here
                    </a>
                    .
                </p>
                <p>
                    For{' '}
                    <span className="font-semibold text-white">
                        Online billing / E-invoice Access
                    </span>
                    , please visit{' '}
                    <a
                        href="https://secure.billtrust.com/liftone/ig/signup"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-yellow underline hover:opacity-80 transition-opacity"
                    >
                        here
                    </a>
                    .
                </p>
            </div>
        </div>
    )
}

export default SignUpInfoBox
